import Step2SunsetMadnessHomepageContent from "./Steps/Step2SunsetMadnessHomepageContent.jsx";
import SunsetMadnessHomepage from "./Templates/SunsetMadnessHomepage.jsx";
import sunsetMadnessHomepageEditorConfig from "./EditorConfigs/sunsetMadnessHomepageEditorConfig.js";

const sunsetMadnessTemplates = {
 "sunset-madness-homepage": {
  id: "sunset-madness-homepage",
  name: "Sunset-Madness-Homepage",
  label: "Sunset Madness",
  desc: "Sunset Madness homepage",
  pageType: "home",
  step2Component: Step2SunsetMadnessHomepageContent,
  publicComponent: SunsetMadnessHomepage,
  editorConfig: sunsetMadnessHomepageEditorConfig,
 },
};

export default sunsetMadnessTemplates;